import type { EnumUnion } from "@dresscode-frontend/utility-types";
import type { GetPlaceListItem } from "../../../-types";

type PlaceTablePlaceColumn = Pick<
  GetPlaceListItem,
  "id" | "name" | "avatarUrl" | "status" | "statusLabel"
>;
type PlaceTableContactColumn = Pick<GetPlaceListItem, "phoneNumber" | "email">;
type PlaceTableAddressColumn = GetPlaceListItem["address"];

export const PlaceTableColumns = {
  CODE: "CODE",
  PLACE: "PLACE",
  CONTACT: "CONTACT",
  WEBSITE: "WEBSITE",
  ADDRESS: "ADDRESS",
  // HEAD: "HEAD",
  ESTABLISHED_DATE: "ESTABLISHED_DATE",
} as const;
export type PlaceTableColumns = EnumUnion<typeof PlaceTableColumns>;

export type PlaceTableRow = {
  [PlaceTableColumns.CODE]: string | undefined;
  [PlaceTableColumns.PLACE]: PlaceTablePlaceColumn;
  [PlaceTableColumns.CONTACT]: PlaceTableContactColumn;
  [PlaceTableColumns.WEBSITE]: string | undefined;
  [PlaceTableColumns.ADDRESS]: PlaceTableAddressColumn;
  [PlaceTableColumns.ESTABLISHED_DATE]: string | undefined;
};

export const convertPlaceItemToTableRow = (
  item: GetPlaceListItem,
): PlaceTableRow => {
  return {
    [PlaceTableColumns.CODE]: item.code,
    [PlaceTableColumns.PLACE]: {
      id: item.id,
      name: item.name,
      avatarUrl: item.avatarUrl,
      status: item.status,
      statusLabel: item.statusLabel,
    },
    [PlaceTableColumns.CONTACT]: {
      email: item.email,
      phoneNumber: item.phoneNumber,
    },
    [PlaceTableColumns.WEBSITE]: item.website,
    [PlaceTableColumns.ADDRESS]: item.address,
    [PlaceTableColumns.ESTABLISHED_DATE]: item.establishedDate,
  };
};
